import { useCallback, useId, useState } from 'react';
import { Typography } from 'modules/v2/foundation/Typography';
import { Tooltip } from '../../Tooltip';
import { Container } from './styled';
export function TableCellText(props) {
    const { primary = '', secondary = '', dense } = props;
    const id = useId();
    const [truncated, setTruncated] = useState({});
    const truncateCheck = useCallback((ref) => {
        if (!ref)
            return;
        const elementId = ref.getAttribute('id');
        const textIsTruncated = ref.offsetWidth < ref.scrollWidth;
        setTruncated((state) => (Object.assign(Object.assign({}, state), { [elementId]: textIsTruncated })));
    }, []);
    const displayTooltip = Object.values(truncated).some((key) => key === true);
    return (<Tooltip title={`${primary} ${secondary}`} disabled={!displayTooltip} width={256}>
      <Container $dense={dense}>
        {primary && (<Typography $truncate id={`${id}-primary`} $appearance="300" $fontSize="small" $lineHeight="neutralized" ref={truncateCheck}>
            {primary}
          </Typography>)}

        {secondary && (<Typography $truncate id={`${id}-secondary`} $appearance="100" $fontSize="tiny" $lineHeight="neutralized" ref={truncateCheck}>
            {secondary}
          </Typography>)}
      </Container>
    </Tooltip>);
}
